import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () =>
  'taz' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({
  key: 'initKeyValue',
  zapierData: [{ key: 'key1', value: 'value1', sampleValue: 'sample value1' }],
});

const { getStore, defaultStore } = createComponentStore({
  type: 'trigger_a_zap',
  endpoint: 'trigger_a_zap',
  registryKey: 'trigger_a_zap',
  initData,

  extraState: () => ({
    placeholders: [],
    position: null,
    error: false,
  }),

  extraActions: (set, get) => ({
    setFocus: (index) => set({ position: index }),
    setPlaceholders: (placeholders) => set({ placeholders: [...placeholders] }),
    keyAuto,

    addNewData: () => {
      const data = JSON.parse(JSON.stringify(get().data));
      if (!data.zapierData) data.zapierData = [];
      const n = data.zapierData.length + 1;
      data.zapierData.push({ key: 'key' + n, value: 'value ' + n, sampleValue: 'sample value ' + n });
      set({ data });
    },

    setDataValue: (index, property, value) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.zapierData[index][property] = value;
      set({ data });
    },

    deleteData: (index) => {
      const data = JSON.parse(JSON.stringify(get().data));
      data.zapierData.splice(index, 1);
      set({ data });
    },
  }),
});

export const getTriggerAZapStore = getStore;
export default defaultStore;
